// extracted by mini-css-extract-plugin
export default {"container":"ModalLoader_container__9KJyJ"};